<template>
	<div :style="{
			borderRadius: styles.borderRadius+'px '+styles.borderRadius+'px '+styles.borderRadius1+'px '+styles.borderRadius1+'px ',
		  }" class="order-navbar">
		<div class="order-box">
			<div class="order-title">我的订单</div>
			<div class="order-txt">
				全部订单<i class="el-icon-arrow-right"></i>
				<!-- <uni-icons type="right" color="#95989d" size="15"></uni-icons> -->
			</div>
		</div>
		<div class="order-item-box">
			<div class="order-navbar-item" v-for="(item, index) in orderNavbar" :key="index" >
				<div class="item-icon">
					<!-- <text class="iconfont" :class="[`icon-${item.icon}`]"></text> -->
					<img :src="item.imgUrl" ></img>
				</div>
				<div class="item-name">{{ item.text }}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			orderNavbar:{
				type:Array,
				default:()=>[]
			},
			styles:{
				type:Object,
				default:{
					borderRadius:0,
					borderRadius1:0
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.order-navbar {
		display: flex;
		flex-direction: column;
		padding: 15px 0 13px 0;
		font-size: 15px;
		background: #fff;
	
		.order-box {
			padding: 0 10px 15px;
			display: flex;
			align-items: center;
			justify-content: space-between;
	
			.order-title {
				font-weight: 600;
			}
	
			.order-txt {
				display: flex;
				align-items: center;
				color: #95989d;
				font-size: 13px;
			}
		}
	
		.order-item-box {
			display: flex;
		}
	
		&-item {
			position: relative;
			width: 25%;
			.item-icon {
				margin: 0 auto;
				padding: 5px 0;
				img {
					width: 26px;
					height: 26px;
					display: block;
					margin: 0 auto;
				}
			}
	
			.item-name {
				font-size: 13px;
				color: #545454;
				text-align: center;
				margin-right: 5px;
			}
		}
	}
</style>